import styled from 'styled-components/macro'
import { Grid } from '@mui/material'
import { Router } from './Router'

import { withGraphql } from 'src/context/GraphQlProvider'
import { spacing } from 'src/utils/styled'
import { Suspense } from 'react'

const RootContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: ${spacing(8)};
`

const RoutesContainer = styled.div``

const FooterSpacer = styled.div`
    width: 100%;
    height: ${spacing(6)};
`

export const App = withGraphql(function App() {
    return (
        <Suspense fallback={<h1>Lade Komponente...</h1>}>
            <RootContainer>
                <ContentContainer>
                    <Grid container overflow={'auto'}>
                        <Grid item xs={12}>
                            <RoutesContainer>
                                <Router />
                                <FooterSpacer />
                            </RoutesContainer>
                        </Grid>
                    </Grid>
                </ContentContainer>
            </RootContainer>
        </Suspense>
    )
})
